/**
 * SearchModal Theme
 *
 * @override
 * - Header has higher z-index than modal when search is open
 * - Uses global blur overlay instead of ModalOverlay
 * - Modal content positioned below header (desktop only, calculated dynamically)
 * - On mobile: Full screen modal with header inside
 * - blockScrollOnMount: true to lock body scroll when modal is open
 */

export default {
  parts: [
    'modal',
    'content',
    'mobileHeader',
    'logoMobileWrapper',
    'logoMobile',
    'closeButton',
    'body',
    'container'
  ],
  baseStyle: {
    modal: {
      blockScrollOnMount: true,
    },
    content: {
      size: 'full',
      bg: 'brandColors.primaryBG',
      backdropFilter: 'blur(20px)',
      position: 'relative',
      minHeight: {base: '100vh', lg: 'auto'},
      containerProps: {
        style: {
          zIndex: 1500, // Will be overridden dynamically for desktop
        },
      },
    },
    mobileHeader: {
      display: {base: 'flex', lg: 'none'},
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingX: {base: '20px', md: '20px'},
      paddingY: {base: '16px', md: '16px'},
      borderBottom: 'none',
    },
    logoMobileWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 'auto',
      padding: 0,
      height: 'auto',
      sx: {
        svg: {
          width: '100%',
          height: '100%',
        },
      },
    },
    logoMobile: {
      maxWidth: {base: '76px', md: '76px'},
      maxHeight: {base: '17px', md: '17px'},
    },
    closeButton: {
      position: {base: 'relative', lg: 'absolute'},
      top: {base: 'auto', lg: 8},
      right: {base: 'auto', lg: 8},
      zIndex: 10,
      width: '20px',
      height: '20px',
      minWidth: '20px',
      minHeight: '20px',
      _hover: {opacity: 0.5},
    },
    body: {
      bg: 'transparent',
      paddingBottom: 6,
      px: {base: 5, md: 7.5},
      pt: 6,
      pb: {base: 10, md: 20},
    },
    container: {
      maxW: {base: 'full', md: '1060px'},
    },
  },
};
